<template>
  <v-container>
    <v-layout justify-center>
      <v-alert
        text
        border="right"
        type="error"
        transition="scale-transition"
        width="60%"
      >
        <h3 style="color: #dc3545" class="headline">Item Not Found!</h3>
        <v-divider></v-divider>
        <br />
        <p>
          If you're currently processing this product - please, follow the
          further operation.
        </p>
        <p>
          - Check if you corretly scanned the code. Maybe the item has multiple
          scanable codes?
        </p>
        <p>
          - Send the item to the warehouse. Continue with your work afterward.
        </p>
        <p>
          You can read about this operation more
          <a href="/" style="font-weight: 700; color: #cd5c5c">here</a>
        </p>
      </v-alert>
    </v-layout>

    <v-layout justify-center>
      <v-card width="60%">
        <v-card-title class="headline grey lighten-2">
          Item not found: {{ SKU }}
        </v-card-title>

        <v-card-title>Please, put this item to {{ noIdBox }} box.</v-card-title>

        <v-card-text class="text--primary">
          The operation with this item won't be counted into your daily
          descriptions amount.<br />
          Click proceed once you put the item into a correct box.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="ma-2" color="success" @click="reset">
            Proceed a new item
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "SearchFailed",
  props: {
    SKU: String,
    noIdBox: String,
  },
  methods: {
    reset() {
      // this.$router.go();
      this.$emit("reset")
    },
  },
};
</script>